function NXCustomer({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1283)">
        <path
          d="M17.4143 7.56617C19.0475 7.56617 20.3714 6.24221 20.3714 4.60903C20.3714 2.97584 19.0475 1.65189 17.4143 1.65189C15.7811 1.65189 14.4572 2.97584 14.4572 4.60903C14.4572 6.24221 15.7811 7.56617 17.4143 7.56617Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.85 14.9594V13.4808C21.85 11.031 19.8641 9.04503 17.4143 9.04503C15.7437 9.04503 14.2888 9.9685 13.5323 11.3328"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.58568 7.56617C7.21887 7.56617 8.54283 6.24221 8.54283 4.60903C8.54283 2.97584 7.21887 1.65189 5.58568 1.65189C3.9525 1.65189 2.62854 2.97584 2.62854 4.60903C2.62854 6.24221 3.9525 7.56617 5.58568 7.56617Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.1499 14.9594V13.4808C1.1499 11.031 3.13589 9.04503 5.58571 9.04503C7.25625 9.04503 8.7111 9.9685 9.46764 11.3328"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5016 16.4343C13.1348 16.4343 14.4588 15.1104 14.4588 13.4772C14.4588 11.844 13.1348 10.52 11.5016 10.52C9.86845 10.52 8.54449 11.844 8.54449 13.4772C8.54449 15.1104 9.86845 16.4343 11.5016 16.4343Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9378 22.3484C15.9378 19.8986 13.9518 17.9127 11.502 17.9127C9.05213 17.9127 7.06616 19.8986 7.06616 22.3484"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1283">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500244)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXCustomer;
